export const CUSTOMER_ACCOUNT_NO = '1500'
export const SUPPLIER_ACCOUNT_NO = '2400'
export const INCOME_ACCOUNT_NO = '3000'
